export default __webpack_public_path__ + "media/images/building_images/placeholder_locations_2-78811525129bacd381e5a49e99f1a0cb.png";